shadow$provide[9] = function(global,require,module,exports) {
module.exports=(React);
};